import { DataAccessFactory } from './DataAccessFactory'
import { Resource } from './dataAccess'

class MetaformFactory extends DataAccessFactory {

    constructor() {
        super()

        this.defaultActions = {}
        this.server = 'metaform'
        this.initialize()
    }


    initialize() {
        const resources: Array<Resource> = [
            {
                name: 'MetaformCache',
                url: '',
                actions: {
                    forms: {
                        method: 'GET',
                        url: 'AP4/forms',
                        isArray: true
                    },
                    clearAll: {
                        method: 'DELETE',
                        url: 'AP4/cache'
                    },
                    clearForm: {
                        method: 'DELETE',
                        url: 'AP4/cache/:formName',
                        params: {
                            formName: '@formName'
                        }
                    }
                }
            }
        ]

        this.process(resources)
    }
}

new MetaformFactory()
